export const images = [
  "avatar_logo.png",
  "sidebar_logo.png",
  "marker.png",
  "login_page_logo.png",
  "calendar.svg"
];



// WEBPACK FOOTER //
// ./src/images/image-list.js